// extracted by mini-css-extract-plugin
export default {"dragging":"TaskEvent_dragging__IIruH"};